module.exports = __webpack_public_path__ + "static-portal/img/news6-1.9146258.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news6-1.png
// module id = aRYe
// module chunks = 4